// API
import { toast } from "react-toastify";
import authAPI from "../apis/authAPI";

const AuthAPI = new authAPI();

const checkAuth = (token) => {
  if (token) {
    let _token = Object.values(token).every((value) => value !== null);
    let _now = new Date();
    let _nowUtc = new Date(
      _now.getUTCFullYear(),
      _now.getUTCMonth(),
      _now.getUTCDate(),
      _now.getUTCHours(),
      _now.getUTCMinutes(),
      _now.getUTCSeconds()
    );

    let access_token_expired = new Date(token.access_token_expires) < _nowUtc;
    let refresh_token_expired = new Date(token.refresh_token_expires) < _nowUtc;

    if (_token) {
      return {
        access_token_expired,
        refresh_token_expired,
      };
    }

    return {
      access_token_expired: true,
      refresh_token_expired: true,
    };
  }

  return {
    access_token_expired: true,
    refresh_token_expired: true,
  };
};

const handleSignIn = (payload, navigate, clearForm, setAuth) => {
  toast.promise(AuthAPI.signin(payload), {
    pending: {
      render() {
        return "Signing in...";
      },
    },
    success: {
      render({ data }) {
        if (data.status === 200) {
          const { token, user } = data.data;

          setAuth({ token, user });

          clearForm();
          navigate("/games", { replace: true });

          return "You have successfully sign in";
        }
      },
    },
    error: {
      render({ data }) {
        if (data.response.status >= 400 && data.response.status < 500) {
          return "Invalid request, check your credentials";
        } else if (data.response.status >= 500) {
          return "There was an error signing out, contact support";
        } else {
          return "Request timed out, please try again";
        }
      },
    },
  });
};

const handleSignOut = (auth, navigate, setAuth) => {
  toast.promise(AuthAPI.signout(auth), {
    pending: {
      render() {
        return "Signing out...";
      },
    },
    success: {
      render({ data }) {
        if (data.status === 200) {
          // clear auth context
          setAuth({ token: null, user: null });

          // navigate to signin
          navigate("/signin", { replace: true });

          return "You have successfully sign out";
        }
      },
    },
    error: {
      render({ data }) {
        if (data.response.status >= 400 && data.response.status < 500) {
          return "Invalid request, check your credentials";
        } else if (data.response.status >= 500) {
          return "There was an error signing out, contact support";
        } else {
          return "Request timed out, please try again";
        }
      },
    },
  });
};

const handleSignUp = async (payload, navigate, clearForm) => {
  toast.promise(AuthAPI.signup(payload), {
    pending: {
      render() {
        return "Signing up...";
      },
    },
    success: {
      render({ data }) {
        if (data.status === 200) {
          clearForm();
          navigate("/signin", { replace: true });

          return "You have successfully sign up";
        }
      },
    },
    error: {
      render({ data }) {
        if (data.response.status >= 400 && data.response.status < 500) {
          return "Invalid request, check your credentials";
        } else if (data.response.status >= 500) {
          return "There was an error signing out, contact support";
        } else {
          return "Request timed out, please try again";
        }
      },
    },
  });
};

const handleUpdate = async (navigate, payload, setAlert, update = "user") => {
  let signup = await AuthAPI.signup(payload, setAlert);

  if (signup) {
    navigate("/signin", { replace: true });
  }
};

export { checkAuth, handleSignIn, handleSignUp, handleUpdate, handleSignOut };
